import React from "react";
import {
  IconMessageChatbot,
  IconReceipt2,
  IconCode,
  IconCheck,
  IconClipboardCheck,
  IconSettings,
} from "@tabler/icons-react";

const cardData = [
  {
    title: "Initial Consultation",
    description: "We start with a detailed discussion to understand your needs and project goals.",
    icon: <IconMessageChatbot size={50} className="text-[#e5471f]" />, // Red from color palette
  },
  {
    title: "Pricing & Proposal",
    description: "Receive a customized quote with a breakdown of costs and project timeline.",
    icon: <IconReceipt2 size={50} className="text-[#e5471f]" />,
  },
  {
    title: "Development Phase",
    description: "Our team gets to work, bringing your vision to life with precision and care.",
    icon: <IconCode size={50} className="text-[#e5471f]" />,
  },
  {
    title: "Project Completion",
    description: "We ensure the project meets expectations and is ready for delivery.",
    icon: <IconCheck size={50} className="text-[#e5471f]" />,
  },
  {
    title: "Client Approval",
    description: "Your feedback is essential—final refinements are made to perfection.",
    icon: <IconClipboardCheck size={50} className="text-[#e5471f]" />,
  },
  {
    title: "Ongoing Maintenance",
    description: "Enjoy peace of mind with our support and maintenance services.",
    icon: <IconSettings size={50} className="text-[#e5471f]" />,
  },
];

const CardHoverEffect = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 py-16 max-w-7xl mx-auto">
      {cardData.map((item, index) => (
        <div
          key={index}
          className={`flex flex-col lg:border-r py-10 relative group dark:border-neutral-800 
            ${(index === 0 || index === 3) && "lg:border-l dark:border-neutral-800"} 
            ${index < 3 && "lg:border-b dark:border-neutral-800"}`}
        >
          {index < 3 && (
            <div className="opacity-0 group-hover:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
          )}
          {index >= 3 && (
            <div className="opacity-0 group-hover:opacity-100 transition duration-200 absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
          )}

          <div className="mb-4 relative z-10 px-10 text-neutral-600 dark:text-neutral-400 flex justify-center">
            {item.icon}
          </div>
          <div className="text-lg font-bold mb-2 relative z-10 px-10">
            <div className="absolute left-0 inset-y-0 h-6 group-hover:h-8 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover:bg-[#e5471f] transition-all duration-200 origin-center" />
            <span className="group-hover:translate-x-2 transition duration-200 inline-block text-neutral-800 dark:text-neutral-100">
              {item.title}
            </span>
          </div>
          <p className="text-sm text-neutral-600 dark:text-neutral-300 max-w-xs relative z-10 px-10">
            {item.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CardHoverEffect;




